<template>
  <div>
    <v-card class="pl-1 py-2">
      <v-card-title>
        Selecione o Período Desejado:
      </v-card-title>
      <v-row no-gutters>
        <v-col md="4" lg="3" xl="2">
          <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-top="48"
            :nudge-right="10"
            transition="scale-transition"
            max-width="290"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                class="mx-2"
                :value="formatDataInicial"
                append-outer-icon="mdi-calendar"
                label="Data Inicial"
                placeholder=" "
                @click:clear="dataInicial = null"
                v-on="on"
                outlined
                readonly
                dense
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dataInicial"
              @change="menu1 = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col md="4" lg="3" xl="2">
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-top="48"
            :nudge-right="10"
            transition="scale-transition"
            max-width="290"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                class="mx-2"
                :value="formatDataFinal"
                append-outer-icon="mdi-calendar"
                label="Data Final"
                placeholder=" "
                @click:clear="dataFinal = null"
                v-on="on"
                outlined
                readonly
                dense
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dataFinal"
              @change="menu2 = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="mx-2" md="4" lg="3" xl="2">
          <v-btn
            @click="carregarDados"
            color="#2A2F50"
            style="height: 30px; margin-top: 2px"
            dark
            small
          >
            <v-icon class="ml-n1 mr-1">mdi-refresh</v-icon>
            Atualizar
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <v-row class="mt-1">
      <v-col md="3" sm="2">
        <v-card class="pl-3 pt-3 pb-3 card-indicador">
          <v-row no-gutters>
            <div>
              <img
                :src="require('@/assets/dashboard-icons/icon1.jpg')"
                alt=""
              />
            </div>
            <div class="div-card-info">
              Carrinhos
              <h1 style="color: rgb(70, 0, 128)">
                {{ getDashboard.totalizadores.carrinhos }}
              </h1>
            </div>
          </v-row>
        </v-card>
      </v-col>
      <v-col md="3" sm="2">
        <v-card class="pl-3 pt-3 pb-3 card-indicador">
          <v-row no-gutters>
            <div>
              <img
                :src="require('@/assets/dashboard-icons/icon2.jpg')"
                alt=""
              />
            </div>
            <div class="div-card-info">
              Pedidos
              <h1 style="color: rgb(70, 0, 128)">
                {{ getDashboard.totalizadores.pedidos }}
              </h1>
            </div>
          </v-row>
        </v-card>
      </v-col>
      <v-col md="3" sm="2">
        <v-card class="pl-3 pt-3 pb-3 card-indicador">
          <v-row no-gutters>
            <div>
              <img
                :src="require('@/assets/dashboard-icons/icon3.jpg')"
                alt=""
              />
            </div>
            <div class="div-card-info">
              Finalizados
              <h1 style="color: rgb(70, 0, 128)">
                {{ getDashboard.totalizadores.finalizados }}
              </h1>
            </div>
          </v-row>
        </v-card>
      </v-col>
      <v-col md="3" sm="2">
        <v-card class="pl-3 pt-3 pb-3 card-indicador">
          <v-row no-gutters>
            <div>
              <img
                :src="require('@/assets/dashboard-icons/icon4.jpg')"
                alt=""
              />
            </div>
            <div class="div-card-info">
              Total Finalizados
              <h3 class="mt-2" style="color: rgb(70, 0, 128)">
                {{
                  formatarMoeda(getDashboard.totalizadores.totalfinalizados, 2)
                }}
              </h3>
            </div>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-n2">
      <v-col md="3" sm="2">
        <v-card class="pl-3 pt-3 pb-3 card-indicador">
          <v-row no-gutters>
            <div>
              <img
                :src="require('@/assets/dashboard-icons/icon5.jpg')"
                alt=""
              />
            </div>
            <div class="div-card-info">
              Alertas Pendentes
              <h1 style="color: rgb(70, 0, 128)">
                {{ getDashboard.totalizadores.alertaspendentes }}
              </h1>
            </div>
          </v-row>
        </v-card>
      </v-col>
      <v-col md="3" sm="2">
        <v-card class="pl-3 pt-3 pb-3 card-indicador">
          <v-row no-gutters>
            <div>
              <img
                :src="require('@/assets/dashboard-icons/icon6.jpg')"
                alt=""
              />
            </div>
            <div class="div-card-info">
              Alertas Resolvidos
              <h1 style="color: rgb(70, 0, 128)">
                {{ getDashboard.totalizadores.alertasresolvidos }}
              </h1>
            </div>
          </v-row>
        </v-card>
      </v-col>
      <v-col md="3" sm="2">
        <v-card class="pl-3 pt-3 pb-3 card-indicador">
          <v-row no-gutters>
            <div>
              <img
                :src="require('@/assets/dashboard-icons/icon7.jpg')"
                alt=""
              />
            </div>
            <div class="div-card-info">
              Interações
              <h1 style="color: rgb(70, 0, 128)">
                {{ getDashboard.totalizadores.interacoes }}
              </h1>
            </div>
          </v-row>
        </v-card>
      </v-col>
      <v-col md="3" sm="2">
        <v-card class="pl-3 pt-3 pb-3 card-indicador">
          <v-row no-gutters>
            <div>
              <img
                :src="require('@/assets/dashboard-icons/icon8.jpg')"
                alt=""
              />
            </div>
            <div class="div-card-info">
              Solicit. de Contato
              <h1 style="color: rgb(70, 0, 128)">
                {{ getDashboard.totalizadores.solicitcontato }}
              </h1>
            </div>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <!-- RANKING -->
    <div v-if="dadosDashboard" class="row mt-n1">
      <div
        v-for="(item, index) in getDashboard.vendedores"
        :key="index"
        class="col-md-4"
      >
        <v-card class="card-profile-1 text-center py-5">
          <div>
            <img class="avatar" :src="item.foto_url" alt />
          </div>
          <h5 class="m-0">
            <span style="font-size: 15px">
              {{ item.nome }}
            </span>
            <img
              v-if="index === 0"
              style="height: 15px"
              :src="require('@/assets/trofeu.png')"
            />
          </h5>
          <p class="mt-1 text-muted">
            Vendedor Nº <b>{{ index + 1 }}</b>
          </p>
          <p>{{ item.pedidos }} pedido(s)</p>
          <v-chip color="primary" dark>
            {{ formatarMoeda(item.total, 2) }}
          </v-chip>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import startCase from 'lodash/startCase'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  data () {
    return {
      dadosDashboard: null,
      dataInicial: moment()
        .startOf('month')
        .format('YYYY-MM-DD'),
      menu1: false,
      dataFinal: moment()
        .endOf('month')
        .format('YYYY-MM-DD'),
      menu2: false,
      dt_inicio: new Date(),
      dt_termino: new Date()
    }
  },
  computed: {
    ...mapGetters('authData', ['loggedInUser']),
    ...mapGetters('dashboard', ['getDashboard']),
    sectionName () {
      return startCase(this.$route.params.sectionSlug)
    },
    formatDataInicial () {
      return this.dataInicial
        ? moment(this.dataInicial).local().format('DD/MM/YYYY')
        : ''
    },
    formatDataFinal () {
      return this.dataFinal ? moment(this.dataFinal).local().format('DD/MM/YYYY') : ''
    }
  },
  mounted () {
    moment().locale('pt-br')
    this.carregarDados()
  },
  methods: {
    ...mapMutations('dashboard', ['SET_DATA_INICIAL', 'SET_DATA_FINAL']),
    ...mapActions('dashboard', ['carregarDashboard']),
    formatarMoeda (number, digits) {
      if (number) {
        number = parseFloat(number).toFixed(digits)
        number = number.toString()
        var pattern = /(-?\d+)(\d{3})/
        while (pattern.test(number)) {
          number = number.replace(pattern, '$1.$2')
        }
        return 'R$ ' + number
      } else {
        return 'R$ 0,00'
      }
    },
    async carregarDados () {
      this.SET_DATA_INICIAL(this.dataInicial)
      this.SET_DATA_FINAL(this.dataFinal)
      // this.dadosDashboard = await this.carregarDashboard({
      //   dataInicial: moment(this.dataInicial + " 00:00:00"),
      //   dataFinal: moment(this.dataFinal + " 23:59:59")
      // });
      // console.log('data_inicial', this.dataInicial)
      // console.log('data_final', this.dataFinal)
      // console.log('data_final_utc', moment(this.dataFinal + " 23:59:59").utc().format("YYYY-MM-DD HH:mm:ss"))
      // console.log('data_final_local', moment(this.dataFinal + " 23:59:59").local().format("YYYY-MM-DD HH:mm:ss"))
      this.dadosDashboard = await this.carregarDashboard({
        dataInicial: moment(this.dataInicial + ' 00:00:00').local().format('YYYY-MM-DD HH:mm:ss'),
        dataFinal: moment(this.dataFinal + ' 23:59:59').local().format('YYYY-MM-DD HH:mm:ss')
      })
    }
  }
}
</script>

<style scoped>
h1 {
  font-weight: 300 !important;
}
h3 {
  font-weight: 300 !important;
}
.card-indicador {
}
.div-card-info {
  margin-left: 30px;
  margin-top: 13px;
  color: gray;
}
.avatar {
  height: 75px;
  border-radius: 50%;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}
</style>
